import { post } from '../utility';

export const searchStations = ({ callback }) => {
	post({
		method: 'tankScrub.stations.search',
		params: {},
		callback,
	});
};

export const preview = ({ stationId, oldTankNumber, newTankNumber, callback }) => {
	post({
		method: 'tankScrub.preview',
		params: { stationId, oldTankNumber, newTankNumber },
		callback,
	});
};

export const execute = ({
	stationId,
	oldTankNumber,
	newTankNumber,
	acknowledgeWarnings,
	callback,
}) => {
	post({
		method: 'tankScrub.execute',
		params: { stationId, oldTankNumber, newTankNumber, acknowledgeWarnings },
		callback,
	});
};
